import { GlButton, GlFormGroup, GlFormRadioGroup, GlIcon, GlTooltipDirective, GlSprintf, GlLink } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import IndexLayout from '../../../vue_shared/components/index_layout.vue?vue3';
import csrf from '~/lib/utils/csrf';
import { I18N, COMPARE_OPTIONS, COMPARE_REVISIONS_DOCS_URL, COMPARE_OPTIONS_INPUT_NAME } from '../constants';
import RevisionCard from './revision_card.vue?vue3';
export default {
    name: 'CompareApp',
    csrf,
    components: {
        RevisionCard,
        GlButton,
        GlFormRadioGroup,
        GlFormGroup,
        GlIcon,
        GlLink,
        GlSprintf,
        IndexLayout
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        projectCompareIndexPath: {
            type: String,
            required: true
        },
        sourceProjectRefsPath: {
            type: String,
            required: true
        },
        targetProjectRefsPath: {
            type: String,
            required: true
        },
        paramsFrom: {
            type: String,
            required: false,
            default: null
        },
        paramsTo: {
            type: String,
            required: false,
            default: null
        },
        projectMergeRequestPath: {
            type: String,
            required: true
        },
        createMrPath: {
            type: String,
            required: true
        },
        sourceProject: {
            type: Object,
            required: true
        },
        targetProject: {
            type: Object,
            required: true
        },
        straight: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            from: {
                selectedProject: this.targetProject,
                revision: this.paramsFrom,
                refsProjectPath: this.targetProjectRefsPath
            },
            to: {
                selectedProject: this.sourceProject,
                revision: this.paramsTo,
                refsProjectPath: this.sourceProjectRefsPath
            },
            isStraight: this.straight
        };
    },
    computed: {
        branchSelectionChanged () {
            return this.from.revision !== this.paramsFrom || this.to.revision !== this.paramsTo;
        },
        areBranchesDifferent () {
            return this.from.revision !== this.to.revision;
        },
        showMrButton () {
            return !this.branchSelectionChanged && (this.projectMergeRequestPath || this.createMrPath);
        },
        showMrStatusMessage () {
            return this.branchSelectionChanged && this.areBranchesDifferent;
        },
        mrButtonHref () {
            return this.projectMergeRequestPath || this.createMrPath;
        },
        mrButtonTestId () {
            return this.projectMergeRequestPath ? 'projectMrButton' : 'createMrButton';
        },
        mrButtonText () {
            return this.projectMergeRequestPath ? this.$options.i18n.viewMr : this.$options.i18n.openMr;
        }
    },
    methods: {
        onSelectProject ({ direction, project }) {
            // direction is either 'from' or 'to'
            this[direction].refsProjectPath = project.refs_url;
            this[direction].selectedProject = {
                ...project
            };
        },
        onSelectRevision ({ direction, revision }) {
            this[direction].revision = revision; // direction is either 'from' or 'to'
        },
        onSwapRevision () {
            [this.from, this.to] = [
                this.to,
                this.from
            ]; // swaps 'from' and 'to'
        }
    },
    i18n: I18N,
    compareOptions: COMPARE_OPTIONS,
    docsLink: COMPARE_REVISIONS_DOCS_URL,
    inputName: COMPARE_OPTIONS_INPUT_NAME
};
